/**
 * this function calculates the sum of an array of numbers
 * @param {array} arr
 * @returns {number}
 */
export const calculateSum = (arr) =>
  +arr
    .reduce((accumulator, currentValue) => accumulator + currentValue)
    .toFixed(2);
